import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { task, timeout } from 'ember-concurrency';
import { action, computed } from '@ember/object';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

const CLASS_NAME = 'GLM-verify-email';

/**
 * @const Query param for the 'token' value base 64 encoded
 */
export const GET_TOKEN = 'token';

/**
 * @const Query param for the 'origin' value base 64 encoded
 */
export const GET_ORIGIN = 'o';

/**
 * @const Query param for the legacy 'token' value base 64 encoded
 */
export const GET_LEGACY_TOKEN = 't';

/**
 * @const Query param for the legacy 'email' value base 64 encoded
 */
export const GET_LEGACY_EMAIL = 'e';

/**
 * @const Query param for the legacy 'userId' value base 64 encoded
 */
export const GET_LEGACY_USER_ID = 'u';

class VerifyEmailController extends Controller {
  queryParams = [GET_TOKEN, GET_ORIGIN, GET_LEGACY_TOKEN, GET_LEGACY_EMAIL, GET_LEGACY_USER_ID];

  [GET_TOKEN] = null;
  [GET_ORIGIN] = null;
  [GET_LEGACY_TOKEN] = null;
  [GET_LEGACY_EMAIL] = null;
  [GET_LEGACY_USER_ID] = null;

  @service auth;
  @service api;
  @service('error-tracker') errorTracker;
  @service router;
  @service session;
  @service('commands/user-commands') userCommandService;

  userId = null;
  origin = null;
  email = null;

  get className() {
    return CLASS_NAME;
  }

  @computed('resendVerifyEmailTask.last.error.errors.{email,newEmail,origin}')
  get resendVerifyEmailTaskError() {
    if (!this.resendVerifyEmailTask.last) {
      return null;
    }

    const { error } = this.resendVerifyEmailTask.last;
    return error
      ? error.errors?.email ?? 'There was a problem re-sending verification email.'
      : null;
  }

  @action
  redirectPasswordReset() {
    this.router.transitionTo(EMBER_ROUTE_NAMES.RESET_PASSWORD);
  }

  @task
  *verifyEmailTask(t, e = null) {
    // cannot clear queryParams in the same runloop as a transition
    yield timeout(1);

    this.setProperties({
      [GET_TOKEN]: null,
      [GET_ORIGIN]: null,
      [GET_LEGACY_TOKEN]: null,
      [GET_LEGACY_EMAIL]: null,
      [GET_LEGACY_USER_ID]: null,
    });

    try {
      yield this.auth.verifyEmail(t, e);
    } catch (e) {
      this.errorTracker.error(`verifyEmail -- can't verify email`, this, e);
      throw e;
    }

    localStorage.removeItem('directAssignmentDraftId');
    localStorage.removeItem('companyJoinRequestId');

    location.replace('/start');
  }

  @task
  *resendVerifyEmailTask() {
    // use legacy values if available
    const userId = this.userId ?? this.session.currentUser.id;
    const email = this.email ?? this.session.currentUser.id;

    try {
      yield this.userCommandService.resendVerifyEmail(userId, this.origin, email);
    } catch (e) {
      this.errorTracker.error(`resendVerifyEmail -- can't re-send verification email`, this, e);
      throw e;
    }
  }
}

export default VerifyEmailController;
